export default "__VITE_ASSET__CCYv7CpQ__"